import clsx from 'clsx';
import type { ReactNode, Ref } from 'react';
import { ProgressBar as RACProgressBar } from 'react-aria-components';
import type { AriaLabelingProps, CommonProps } from '../../types.js';

interface SpinnerProps extends CommonProps, AriaLabelingProps {
  children?: ReactNode;
  spinnerRef?: Ref<HTMLDivElement>;
  size: string;
}

/**
 * Displays a variable-size loading indicator to represent an ongoing operation.
 *
 * @internal
 */
function Spinner({ children, spinnerRef, size, UNSAFE_className, UNSAFE_style, ...props }: SpinnerProps) {
  return (
    <RACProgressBar
      {...props}
      isIndeterminate
      ref={spinnerRef}
      className={clsx('cim-spinner', UNSAFE_className)}
      style={UNSAFE_style}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 80 80"
        width={size}
        height={size}
        preserveAspectRatio="xMidYMid"
        aria-hidden
      >
        <circle className="cim-spinner-ring-bg" cx="40" cy="40" r="35" />
        <circle className="cim-spinner-ring-fg" cx="40" cy="40" r="35" />
      </svg>
      {children}
    </RACProgressBar>
  );
}

Spinner.displayName = 'Spinner';

export { Spinner as InternalSpinner };
